import React from "react";

export const ALL_VALUE = "all";

export const ENROLLED_PROGRAM_OPTIONS = [
  { value: ALL_VALUE, label: "All Programs" },
  { value: "", label: "None" },
  //{ value: "CCM", label: "CCM" },
  { value: "RPM", label: "RPM" },
  { value: "CCM&RPM", label: "CCM & RPM" }
];

export const EXPECTATION_OPTIONS = [
  { value: ALL_VALUE, label: "All Expectations" },
  { value: "No Adherence Logic", label: "No Adherence Logic" },
  //{ value: "CCM Only", label: "CCM Only" },
  { value: "Adherence on Hold", label: "Adherence on Hold" },
  { value: "MVV Adherence", label: "MVV Adherence" },
  { value: "ANS Adherence", label: "ANS Adherence" },
  { value: "Care Provider Adherence", label: "Care Provider Adherence" }
];

const NoReadingFilter = ({
  enrolledProgramFilter,
  expectationFilter,
  careProviderFilter,
  organizationFilter,
  careProviderOptions = [],
  organizationOptions = [],
  onEnrolledProgramChange,
  onExpectationChange,
  onCareProviderChange,
  onOrganizationChange,
  onReset,
  isFilterActive
}) => {
  return (
    <div className="cpt-filter-wrapper no-reading-filter-wrapper">
      <div className="filter-card-modern">
        <div className="filter-header-section">
          <div className="filter-icon-wrapper">
            <i className="mdi mdi-filter-variant"></i>
          </div>
          <div className="filter-title-section">
            <h4>Filter Patients</h4>
            <p>Narrow the list by Enrolled Program(s), Client Expectation to Follow, Main Care Provider, or Organization</p>
          </div>
        </div>
        <div className="filter-grid-row">
          <div className="filter-input-group">
            <label className="filter-label">
              <i className="mdi mdi-clipboard-pulse-outline"></i>
              Enrolled Program(s)
            </label>
            <select
              className="filter-select-modern"
              value={enrolledProgramFilter}
              onChange={(e) => onEnrolledProgramChange(e.target.value)}
            >
              {ENROLLED_PROGRAM_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input-group">
            <label className="filter-label">
              <i className="mdi mdi-account-check-outline"></i>
              Client Expectation to Follow
            </label>
            <select
              className="filter-select-modern"
              value={expectationFilter}
              onChange={(e) => onExpectationChange(e.target.value)}
            >
              {EXPECTATION_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input-group">
            <label className="filter-label">
              <i className="mdi mdi-doctor"></i>
              Main Care Provider
            </label>
            <select
              className="filter-select-modern"
              value={careProviderFilter}
              onChange={(e) => onCareProviderChange(e.target.value)}
            >
              <option value={ALL_VALUE}>All Care Providers</option>
              {careProviderOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-input-group">
            <label className="filter-label">
              <i className="mdi mdi-office-building-outline"></i>
              Organization
            </label>
            <select
              className="filter-select-modern"
              value={organizationFilter}
              onChange={(e) => onOrganizationChange(e.target.value)}
            >
              <option value={ALL_VALUE}>All Organizations</option>
              {organizationOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-actions-section">
            <button
              type="button"
              className="filter-btn-reset-modern"
              onClick={onReset}
              disabled={!isFilterActive}
            >
              <i className="mdi mdi-refresh"></i>
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoReadingFilter;
